module.exports = require('./$.global').document && document.documentElement;


//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/modules/$.html.js
// module id = 116
// module chunks = 0